var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._b({class:_vm.svgClass,attrs:{"id":_vm.svgId,"title":_vm.svgTitle},domProps:{"innerHTML":_vm._s(_vm.svgData)}},'svg',_vm.svgAttributes,false))
}
var staticRenderFns = []

export { render, staticRenderFns }